import Vocabulary from '@/api/QVocabularyItem'

const getDefaultState = () => {
  return {
    currentVocabulary: {},
    vocabularies: [],
  }
}

// initial state
const state = getDefaultState()

const getters = {}

const actions = {
  // async functions trow errors to view
  async ADD_VOCABULARY({ dispatch, rootGetters }, vocabulary) {
    await Vocabulary.post(rootGetters.centro_id, vocabulary)
    dispatch('GET_VOCABULARIES')
  },

  async DELETE_VOCABULARY({ dispatch, rootGetters }, vocabulary) {
    await Vocabulary.delete(rootGetters.centro_id, vocabulary.id)
    dispatch('GET_VOCABULARIES')
  },

  async UPDATE_VOCABULARY({ dispatch, rootGetters }, vocabulary) {
    await Vocabulary.put(rootGetters.centro_id, vocabulary.id, vocabulary)
    dispatch('GET_VOCABULARIES')
  },

  async COPY_FROM_PARENT({ dispatch, rootGetters }) {
    await Vocabulary.copyFromParent(rootGetters.centro_id)
    dispatch('GET_VOCABULARIES')
  },

  async GET_VOCABULARY({ commit, rootGetters }, id) {
    const response = await Vocabulary.put(rootGetters.centro_id, id)
    commit('SET_CURRENT_VOCABULARY', response.data)
  },

  async GET_VOCABULARIES({ commit, rootGetters }) {
    try {
      const response = await Vocabulary.getQVocabularyItems(rootGetters.centro_id)
      commit('SET_VOCABULARIES', response)
    } catch (error) {
      console.error(
        `Error ${error.response.status} getting list of vocabularies`
      );
    }
  },
}

const mutations = {
  SET_CURRENT_VOCABULARY(state, vocabulary) {
    state.currentVocabulary = vocabulary
  },

  SET_VOCABULARIES(state, vocabularies) {
    var tmpvocabularies = []
    flatten(tmpvocabularies, vocabularies, 0)
    state.vocabularies = tmpvocabularies
  },
}

/* Calls itself to flatten the vocabularies tree */
function flatten(state, vocabularies, level) {
  vocabularies.map(vocabulary => {
    vocabulary.indent = level
    state.push(vocabulary)
    if (vocabulary.items && vocabulary.items.length) flatten(state, vocabulary.items, level + 1)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
